import React from "react";

const PostLIstHeader = () => {
  return (
    <li className="header">
      <div className="list-inner">
        <div className="name">Name</div>
        <div>Created</div>
        <div className="button-container">Action</div>
      </div>
    </li>
  );
};

export default PostLIstHeader;
